import { render, staticRenderFns } from "./v-upload.vue?vue&type=template&id=37a88650&"
import script from "./v-upload.vue?vue&type=script&lang=js&"
export * from "./v-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports